import React, { Component } from "react";
import styles from "./Item.module.css";
import constants from "../../data/constants.json";
import Anchor from "../Anchor/Anchor";
import PropTypes from "prop-types";

class Item extends Component {
  render() {
    const { product } = this.props;
    const filteredServices = constants.services.filter(
      (key) => product[key] != null
    );

    return (
      <div className={styles.container}>
        <img src={`/images/${product.imageName}`} alt={product.name}></img>
        <div className={styles.content}>
          <h1>{product.name}</h1>
          <p className={styles.summary}>{product.summary}</p>
          {filteredServices // null でない要素のみをフィルタリング
            .map((key) => (
              <p key={key}>
                <Anchor title={`for ${key}`} url={product[key]} />
              </p>
            ))}
        </div>
      </div>
    );
  }
}

Item.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
};

export default Item;
